import { Card, Typography } from 'antd';
import { ICourse } from 'interfaces/courses';
import { formatDate } from 'services/date';

const { Text } = Typography;

interface CourseInfoCardProps {
  course: ICourse;
  completedAt: string;
}

export const CourseInfoCard = ({
  course,
  completedAt
}: CourseInfoCardProps) => {
  return (
    <Card size="small" className="border-0 shadow-none bg-transparent">
      <Text strong className="block">
        {course.name}
      </Text>
      <Text type="secondary" className="block text-sm">
        Código: {course.code || '-'}
      </Text>
      <Text type="secondary" className="block text-sm">
        Conclusão: {formatDate(completedAt, 'DD/MM/YYYY')}
      </Text>
    </Card>
  );
};
